<!-- eslint-disable vue/no-mutating-props -->
<template v-if="contentStore.select_component != null">

  <div class="info-slider-row">
    <div class="info-slider-label">{{ title }}</div>
    <div class="info-slider-container">
        <input type="range" :min="min" :max="max" :step="step" 
          v-model="object[property]" class="info-slider"
          @change="changecallbacksave" @keydown="keydownHandler" @input="changecallback"
          >
    </div>
    <input class="info-opacity-input" type="number" v-model="object[property]" @change="changecallback" @keydown="keydownHandler" />
     
  </div>

</template>


<script>
import { useContentStore } from "@/stores/content";

    export default {

        props:{
          
          object:{
            type:Object,
            default(){
              return {}
            }
          },

          title:{
            type:String,
            default(){
              return "";
            }
          },

          property:{
            type:String,
            default(){
              return "";
            }
          },

          min:{
            type:Number, default(){return 0;}
          },
          max:{
            type:Number, default(){return 100;}
          },
          step:{
            type:Number, default(){return 1;}
          },
          
        },

        setup(){
          //let colorstring = ref(props.color);
          const contentStore = useContentStore();
          return {contentStore};
        },

        mounted(){
          
        },

        data: ()=> ({
            text_backup:"",
        }),

        methods: {

          keydownHandler(event){
            //del키를 누르면 컴포넌트가 삭제된다. 따라서 인풋창의 모든 키입력의 이벤트 전파를 막는다.
            event.stopPropagation();
          },

          changecallback(){
              this.updateRender(false);
          }, 

          changecallbacksave(){
              this.updateRender(true);
          }, 

          //편집창 컴포넌트 렌더링
          updateRender(save){
              if(this.contentStore.select_component != null){
                  if(save) this.contentStore.saveSnapshot();
                  this.contentStore.select_component.updateRender();
              }
          },

        }

    }
</script>

<style scoped>


</style>